import { ZipcodeAddress } from '../types'

export const customerAddressesMapper = (
  data: ZipcodeAddress[]
): ZipcodeAddress[] => {
  const address = data.map((address) => {
    return {
      bairro: address.bairro,
      cep: address.cep,
      complemento: address.complemento,
      id: address.id,
      logradouro: address.logradouro,
      numero: address.numero,
      padrao: address.padrao,
    }
  })

  return address
}
